export const HIDE_THIRD_PARTY_DIALOG = "_hide_third_party_dialog_wonder";
export const DISCOVER_WONDER_PAGE = "_discover_wonder_page";
